import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

function useGiftItems(giftCategoryId: string) {
  const { data: items, status } = useQuery({
    ...queries.giftItem.list(giftCategoryId),
    enabled: !!giftCategoryId,
  });
  const toast = useToast();
  const { pop } = useFlow();
  useEffect(() => {
    if (status === 'error') {
      toast.error('선물 목록을 불러오는데 실패했습니다.');
      pop();
    }
  }, [status, pop, toast]);
  return {
    items,
  };
}

export default useGiftItems;
